<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 14L17 17M17 17L14 20M17 17L14 14M17 17L20 20" stroke="currentColor" stroke-width="1.5"/>
    <path d="M3 17H11" stroke="currentColor" stroke-width="1.5"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 14C8 14.5523 7.55228 15 7 15C6.44772 15 6 14.5523 6 14C6 13.4477 6.44772 13 7 13C7.55228 13 8 13.4477 8 14ZM8 20C8 20.5523 7.55228 21 7 21C6.44772 21 6 20.5523 6 20C6 19.4477 6.44772 19 7 19C7.55228 19 8 19.4477 8 20Z" fill="currentColor"/>
    <path d="M13 7H21" stroke="currentColor" stroke-width="1.5"/>
    <path d="M7 3V11M3 7H11" stroke="currentColor" stroke-width="1.5"/>
    </svg>
</template>